import { render, staticRenderFns } from "./BatchInfoModal.vue?vue&type=template&id=390b0493&scoped=true&lang=pug"
import script from "./BatchInfoModal.vue?vue&type=script&lang=js"
export * from "./BatchInfoModal.vue?vue&type=script&lang=js"
import style0 from "./BatchInfoModal.vue?vue&type=style&index=0&id=390b0493&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390b0493",
  null
  
)

export default component.exports